<template>
  <b-modal
    id="modal_form"
    ref="modal_form"
    :title="modal_titulo"
    :ok-title="modal_botao"
    close-title="Fechar"
    cancel-title="Cancelar"
    :ok-disabled="form.errors.any()"
    no-close-on-backdrop
    v-model="showModal"
    @ok="handleOk"
  >
    <form
      @submit.stop.prevent="handleOk"
      @keydown="form.errors.clear($event.target.name)"
    >
      <label>Municipio</label>
      <multiselect
        v-model="municipioSelected"
        :options="optionsMunicipio"
        track-by="value"
        label="label"
        :hide-selected="true"
        placeholder="Selecione"
        tag-placeholder="Selecionar"
        select-label="Selecionar"
        selected-label="Selecionado"
        deselect-label="Remover"
      ></multiselect>
      <b-form-feedback
        v-text="form.errors.get('municipio.value')"
        v-if="form.errors.has('municipio.value')"
      ></b-form-feedback>
      <div v-if="this.modal_acao == 'i'">
        <label>Alíquota Iss</label>
        <currency-input
          class="form-control"
          v-model="municipio_iss_vigencia.aliquota_iss"
          :auto-decimal-mode="true"
          placeholder="Alíquota"
          :currency="{ prefix: '%' }"
          :distraction-free="getCurrency"
        />
        <b-form-feedback
          v-text="form.errors.get('municipio_iss_vigencia.aliquota_iss')"
          v-if="form.errors.has('municipio_iss_vigencia.aliquota_iss')"
        ></b-form-feedback>
      </div>
      <div v-if="this.modal_acao == 'i'">
        <label>Alíquota Iss fora Município</label>
        <currency-input
          class="form-control"
          v-model="municipio_iss_vigencia.aliquota_iss_fora_municipio"
          :auto-decimal-mode="true"
          placeholder="Alíquota Fora Município"
          :currency="{ prefix: '%' }"
          :distraction-free="getCurrency"
        />
        <b-form-feedback
          v-text="form.errors.get('municipio_iss_vigencia.aliquota_iss')"
          v-if="form.errors.has('municipio_iss_vigencia.aliquota_iss')"
        ></b-form-feedback>
      </div>
      <label>Status</label>
      <multiselect
        v-model="statusSelected"
        :options="optionsLivStatus"
        track-by="value"
        label="label"
        :hide-selected="true"
        placeholder="Selecione"
        tag-placeholder="Selecionar"
        select-label="Selecionar"
        selected-label="Selecionado"
        deselect-label="Remover"
      ></multiselect>
      <b-form-feedback
        v-text="form.errors.get('status.value')"
        v-if="form.errors.has('status.value')"
      ></b-form-feedback>
      <div v-if="this.modal_acao == 'i'">
        <label>Data Inicial</label>
        <div class="fl-flex-label fl-collapsed fl-background">
          <input
            v-mask="'##/##/####'"
            type="text"
            class="form-control"
            v-model="municipio_iss_vigencia.dt_vigencia_ini"
          />
          <label
            class="fl-label"
            for="default-input"
            style="left: 13px; right: 12px"
            >Data Inicio</label
          >
        </div>
        <label>Data Final</label>
        <div class="fl-flex-label fl-collapsed fl-background">
          <input
            v-mask="'##/##/####'"
            type="text"
            class="form-control"
            v-model="municipio_iss_vigencia.dt_vigencia_fim"
          />
          <label
            class="fl-label"
            for="default-input"
            style="left: 13px; right: 12px"
            >Data Final</label
          >
        </div>
      </div>
    </form>
    <div slot="modal-footer" class="w-100">
      <div class="float-left">
        <spinner v-if="loading" message="Processando..."></spinner>
      </div>
      <div class="float-right">
        <AvisoErros v-bind:errors_array="errors_array"></AvisoErros>
        <b-btn @click="showModal = false" variant="secondary"> Fechar </b-btn>
        <b-btn
          @click="handleOk($event)"
          variant="primary"
          :disabled="isDisabled"
        >
          Enviar
        </b-btn>
      </div>
    </div>
  </b-modal>
</template>
<script>
import AvisoErros from "../components/AvisoErros";

export default {
  components: {
    AvisoErros
  },
  props: {
    metodo: { type: Function },
    tabela: "",
    rota: ""
  },
  data() {
    return {
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      loading: false,
      isDisabled: false,
      loadingData: true,
      showModal: false,
      showModalGrupo: false,
      isFullscreen: false,
      isLoadingPessoa: false,
      dt_vigencia_ini: "",
      dt_vigencia_fim: "",
      optionsLivStatus: [],
      optionsMunicipio: [],
      statusSelected: [],
      municipioSelected: [],
      municipio_iss_vigencia: {},
      errors_array: [],
      dt_inicio: "",
      dt_fim: "",
      helpForm: new Form({
        statusRecord: [],
        params: []
      }),
      form: new Form({
        municipio_iss_vigencia: {},
        municipio_id: "",
        status: "",
        muniss_id: "",
      }),
      fields: [],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger"
      },
      moreParams: {}
    };
  },
  watch: {
    statusSelected(obj) {
      this.form.status = obj.value;
    },
    municipioSelected(obj) {
      this.form.municipio_id = obj.value;
    }
  },
  mounted() {
    this.getLivGeral();
  },
  methods: {
    handleOk(e) {
      e.preventDefault();
      if (this.modal_acao == "i") {
        this.onStore();
      } else {
        this.onUpdate(this.form.muniss_id);
      }
    },
    onCreate() {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Cadastrar";
      this.modal_botao = "Cadastrar";
      this.modal_acao = "i";
      this.form.reset();
      this.municipio_iss_vigencia = {}
      this.errors_array = "";
      this.errors_array = [];
      this.statusSelected = [];
      this.municipioSelected = [];
      this.$refs.modal_form.show();
    },
    onEdit(data, index, id) {
      this.isDisabled = false;
      this.loading = false;
      this.modal_titulo = "Alterar";
      this.modal_botao = "Alterar";
      this.modal_acao = "u";
      this.form.reset();
      this.municipio_iss_vigencia = {}
      this.errors_array = "";
      this.errors_array = [];
      this.statusSelected = [];
      this.municipioSelected = [];
      this.enviaEmailSelected = [];
      this.statusSelected = {
        label: data.status.descr,
        value: data.status.valor
      };
      this.municipioSelected = {
        label: data.municipio.nome + " - " + data.municipio.cd_ibge,
        value: data.municipio.municipio_id
      };
      this.form.muniss_id = id;
      this.$refs.modal_form.show();
    },
    onStore() {
      this.loading = true;
      this.isDisabled = true;
      this.municipio_iss_vigencia.status = 1;
      this.form.muniss_id = this.form.municipio_id;
      this.form.municipio_iss_vigencia = this.municipio_iss_vigencia;
      this.form
        .post("/api/" + this.rota + "/store")
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.$parent.$refs.vuetable.reload();
          }
        })
        .catch(errors => {
          this.municipio_iss_vigencia = this.form.municipio_iss_vigencia;
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onUpdate(id) {
      this.loading = true;
      this.isDisabled = true;
      this.municipio_iss_vigencia.status = 1;
      this.form.municipio_iss_vigencia = this.municipio_iss_vigencia;
      this.form
        .patch("/api/" + this.rota + "/update/" + id)
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.$parent.$refs.vuetable.reload();
          }
        })
        .catch(errors => {
          this.municipio_iss_vigencia = this.form.municipio_iss_vigencia;
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    onActivateDesactivate(helpForm) {
      helpForm
        .patch("/api/" + this.rota + "/status")
        .then(response => {
          new ReturnApi(response, this);
          if (this.metodo != null) {
            this.$parent.$refs.vuetable.reload();
          }
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },
    getLivGeral() {
      this.helpForm
        .get("/api/municipioiss/jsonlistgeral")
        .then(response => {
          new ReturnApi(response, this, true, false, false);
          response.status.forEach(obj => {
            this.optionsLivStatus.push({ label: obj.descr, value: obj.valor });
          });

          response.municipio.forEach(obj => {
            this.optionsMunicipio.push({
              label: obj.nome + " - " + obj.cd_ibge,
              value: obj.municipio_id
            });
          });
        })
        .catch(errors => {
          new ReturnApi(errors, this, true, null, null, false);
          this.errors_array = "";
          this.errors_array = [];
          for (var property in errors) {
            if (errors.hasOwnProperty(property)) {
              if (typeof errors[property] === "object") {
                errors[property].forEach(obj => {
                  this.errors_array.push({
                    erro: obj
                  });
                });
              }
            }
          }
        });
    },

    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
    getPermission(checkPermission) {
      return this.getPermissionFw(checkPermission);
    }
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      }
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency;
      }
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      }
    }
  }
};
</script>
